<div fxLayout="row" fxFlex="100" id="formRange">
  <div fxLayout="row" fxFlex="8" fxFlex.sm="15">
    <mat-label style="color:black"><strong>Du</strong></mat-label>
  </div>
  <div fxLayout="row" fxFlex="42" fxFlex.sm="35">
    <input matInput [matDatepicker]="FromReceptionDate" (dateChange)="dateChange(typeFrom, $event.value);" [(ngModel)]="_valueFrom" placeholder="01/01/0001">
    <mat-datepicker-toggle matSuffix [for]="FromReceptionDate"></mat-datepicker-toggle>
    <mat-datepicker #FromReceptionDate></mat-datepicker>
  </div>
  <div fxLayout="row" fxFlex="8" fxFlex.sm="15" class="beforeToDate">
    <mat-label style="color:black"><strong>Au</strong></mat-label>
  </div>
  <div fxLayout="row" fxFlex="42" fxFlex.sm="35">
    <input matInput [matDatepicker]="ToReceptionDate" (dateChange)="dateChange(typeTo, $event.value);" [(ngModel)]="_valueTo" placeholder="01/01/0001">
    <mat-datepicker-toggle matSuffix [for]="ToReceptionDate"></mat-datepicker-toggle>
    <mat-datepicker #ToReceptionDate></mat-datepicker>
  </div>
</div>